export default function highlight(query: string, str: string) {
    query = String(query);
    str = String(str);
    return str.replace(new RegExp('(' + query + ')', 'i'), '<span class="highlight-search-result">$1</span>');
}
